export enum TimeTrackerViews {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
